class EOHomeRail extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.track = this.querySelector('[data-rail-track]');
    this.previousButton = this.querySelector('[data-rail-prev]');
    this.nextButton = this.querySelector('[data-rail-next]');
    this.counter = this.querySelector('[data-rail-count]');
    this.slides = [...(this.track?.children ?? [])];
    if (!this.track || !this.previousButton || !this.nextButton || !this.counter || !this.slides.length) return;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track || !this.isMobile || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move(event.key === 'ArrowRight' ? 1 : -1);
    });
    this.track.addEventListener('scroll', () => {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.sync());
    }, { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.sync());
    this.resizeObserver.observe(this.track);
    this.sync();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
  }

  get isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  get index() {
    if (!this.isMobile) return 0;
    const firstLeft = this.slides[0].offsetLeft;
    return this.slides.reduce((closest, slide, index) => {
      const distance = Math.abs(this.track.scrollLeft - (slide.offsetLeft - firstLeft));
      return distance < closest.distance ? { index, distance } : closest;
    }, { index: 0, distance: Infinity }).index;
  }

  move(direction) {
    if (!this.isMobile) return;
    const target = Math.max(0, Math.min(this.slides.length - 1, this.index + direction));
    this.track.scrollTo({
      left: this.slides[target].offsetLeft - this.slides[0].offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

  sync() {
    const index = this.index;
    this.counter.textContent = `${index + 1} / ${this.slides.length}`;
    this.previousButton.disabled = index === 0;
    this.nextButton.disabled = index === this.slides.length - 1;
  }
}

if (!customElements.get('eo-home-rail')) customElements.define('eo-home-rail', EOHomeRail);

